import * as types from "./types";

export const PermissionInitialState = {
  //post request of permission
  permissionPostLoading: false,
  permissionPostError: null,

  //get request of permission
  allPermission: null,
  allPermissionLoading: false,
  allPermissionError: null,

  //get Indivisual permission
  permission: null,
  permissionLoading: false,
  permissionError: null,
};

export const permissionReducer = (state = PermissionInitialState, action: any) => {
  switch (action.type) {
    case types.PERMISSION_FETCH_START:
      return {
        ...state,
        permissionLoading: true,
      };
    case types.PERMISSION_FETCH_SUCCESS:
      return {
        ...state,
        permission: action.permission,
        permissionLoading: false,
      };

    case types.PERMISSION_FETCH_FAILURE:
      return {
        ...state,
        permissionError: action.permissionError,
        permissionLoading: false,
      };

    case types.ALL_PERMISSION_FETCH_START:
      return {
        ...state,
        allPermissionLoading: true,
      };
    case types.ALL_PERMISSION_FETCH_SUCCESS:
      return {
        ...state,
        allPermission: action.allPermission.data,
        allPermissionLoading: false,
      };

    case types.ALL_PERMISSION_FETCH_FAILURE:
      return {
        ...state,
        allPermissionError: action.allPermissionError,
        allPermissionLoading: false,
      };

    case types.PERMISSION_POST_START:
      return {
        ...state,
        permissionPostLoading: true,
      };
    case types.PERMISSION_POST_SUCCESS:
      return {
        ...state,
        permissionPostLoading: false,
      };

    case types.PERMISSION_POST_FAILURE:
      return {
        ...state,
        permissionPostError: action.permissionPostError,
        permissionPostLoading: false,
      };

    default:
      return state;
  }
};
